module.exports = __webpack_public_path__ + "img/logo-eccovia-full.54e76b6c.png";